



























import { Component, mixins, Prop } from 'nuxt-property-decorator'
import MixinGeneral from '~/assets/mixins/general'
import { IPriceItem } from '~/assets/interfaces/price'
import ComponentPrice from '~/components/price/price.vue'
@Component({
  components: {
    ComponentPrice,
  },
})
export default class ComponentProductDetailPricesLight extends mixins(
  MixinGeneral
) {
  @Prop({ type: Array, default: () => [] }) readonly prices: IPriceItem[]
  @Prop({ type: String, default: null }) readonly unit!: string
}
